import { ServiceType } from './services';

export const defaultLangKey = 'default_lang';
export const companyServicesKey = 'companyServices';
export const accessTokenKey = 'access_token';
export const refreshTokenKey = 'refresh_token';
export const refreshExpiresInKey = 'expires_in';

export const tableSettingsKey = 'table_settings';

export const hasService = (service: ServiceType) => {
  const services = localStorage.getItem(companyServicesKey);
  if (!services?.length) return null;

  const splited = services.split(',') as ServiceType[];
  return splited.includes(service);
};

export const pushNotificationKey = 'pushNotification';
export const fbKey = 'firebase';

export const appVersionKey = 'appVersion';
